import React from 'react';
import PropTypes from 'prop-types';

import injectSheet from 'react-jss';

import BracketStyles from './Bracket_Styles';

import store from '../../../redux/store';

import Match from './Match';
import MatchM from './MatchM';
import Winner from './Winner';
import Finals from './Finals';
import Third from './Third';

const styles = BracketStyles;

const Bracket = ({
  classes,
  match,
}) => (
  <div>
    {window.innerWidth >= 600 && (
      <div style={{ marginBottom: '100px' }}>

        <div className={classes.bracketintro}>
          <span className={classes.title}>KNOCKOUT STAGE</span>
          <span> Pick your favorites from each matchup. </span>
        </div>
        {Object.values(store.getState().picks).filter((itm) => itm.teamId !== null).length > 0 && (
        <div className={classes.bracketIntroInfo}>
          <em>Click on a flag to quickly select a team or click on a bar/name for Stats.</em>
        </div>
        )}

        <div className={classes.bracket}>
          <div className={classes.bracketcontent}>
            {/* Leftside of the Bracket */}
            {/* Eighths */}
            <div className={classes.eighths_left}>
              <div className={classes.match_left}>
                <Match id="W49" placeholders={['1st GRP A', '2nd GRP B']} teamz={['A1', 'B2']} />
              </div>
              <div className={classes.match_left}>
                <Match id="W50" placeholders={['1st GRP C', '2nd GRP D']} teamz={['C1', 'D2']} />
              </div>
              <div className={classes.match_left}>
                <Match id="W53" placeholders={['1st GRP E', '2nd GRP F']} teamz={['E1', 'F2']} />
              </div>
              <div className={classes.match_left}>
                <Match id="W54" placeholders={['1st GRP G', '2nd GRP H']} teamz={['G1', 'H2']} />
              </div>
            </div>

            {/* Quarters */}

            <div className={classes.quarters_left}>
              <div className={classes.match_left}>
                <Match id="W57" placeholders={['W49', 'W50']} teamz={['W49', 'W50']} />
              </div>
              <div className={classes.spacer} />
              <div className={classes.match_left}>
                <Match id="W58" placeholders={['W53', 'W54']} teamz={['W53', 'W54']} />
              </div>
            </div>

            {/* Semis */}

            <div className={classes.semis_left}>
              <div className={classes.match_left}>
                <Match id="W61" placeholders={['W57', 'W58']} teamz={['W57', 'W58']} />
              </div>
            </div>

            {/* Finals */}

            <div className={classes.finals}>
              <Winner id="W64" />
              <div className={classes.final}>
                <Finals id="W64" placeholders={['W61', 'W62']} teamz={['W61', 'W62']} roundName="Final" />
              </div>
              <Third id="W63" />
              <div className={classes.thirdfourth}>
                <Finals id="W63" placeholders={['L61', 'L62']} teamz={['L61', 'L62']} roundName="3rd Place Play-Off" />
              </div>
            </div>

            {/* Right Side of Bracket */}

            {/* Semis  */}
            <div className={classes.semis_right}>
              <div className={classes.match_right}>
                <Match id="W62" placeholders={['W59', 'W60']} teamz={['W59', 'W60']} reverse />
              </div>
            </div>

            {/* Quarters */}

            <div className={classes.quarters_right}>
              <div className={classes.match_right}>
                <Match id="W59" placeholders={['W51', 'W52']} teamz={['W51', 'W52']} reverse />
              </div>
              <div className={classes.spacer} />
              <div className={classes.match_right}>
                <Match id="W60" placeholders={['W55', 'W56']} teamz={['W55', 'W56']} reverse />
              </div>
            </div>

            {/* Eighths */}

            <div className={classes.eighths_right}>
              <div className={classes.match_right}>
                <Match id="W51" placeholders={['1st GRP B', '2nd GRP A']} teamz={['B1', 'A2']} reverse />
              </div>
              <div className={classes.match_right}>
                <Match id="W52" placeholders={['1st GRP D', '2nd GRP C']} teamz={['D1', 'C2']} reverse />
              </div>
              <div className={classes.match_right}>
                <Match id="W55" placeholders={['1st GRP F', '2nd GRP E']} teamz={['F1', 'E2']} reverse />
              </div>
              <div className={classes.match_right}>
                <Match id="W56" placeholders={['1st GRP H', '2nd GRP F']} teamz={['H1', 'G2']} reverse />
              </div>
            </div>
          </div>
        </div>

      </div>
    )}
    {(window.innerWidth < 600 && (
      <div>
        <div className={classes.roundsmobile} style={{ display: match.params.bracketSection === 'eighths' ? 'flex' : 'none' }}>
          <MatchM id="W49" placeholders={['1st GRP A', '2nd GRP B']} teamz={['A1', 'B2']} />
          <MatchM id="W50" placeholders={['1st GRP C', '2nd GRP D']} teamz={['C1', 'D2']} />
          <MatchM id="W53" placeholders={['1st GRP E', '2nd GRP F']} teamz={['E1', 'F2']} />
          <MatchM id="W54" placeholders={['1st GRP G', '2nd GRP H']} teamz={['G1', 'H2']} />
          <MatchM id="W51" placeholders={['1st GRP B', '2nd GRP A']} teamz={['B1', 'A2']} />
          <MatchM id="W52" placeholders={['1st GRP D', '2nd GRP C']} teamz={['D1', 'C2']} />
          <MatchM id="W55" placeholders={['1st GRP F', '2nd GRP E']} teamz={['F1', 'E2']} />
          <MatchM id="W56" placeholders={['1st GRP H', '2nd GRP F']} teamz={['H1', 'G2']} />
        </div>
        <div className={classes.roundsmobile} style={{ display: match.params.bracketSection === 'quarters' ? 'flex' : 'none' }}>
          <MatchM id="W57" placeholders={['W49', 'W50']} teamz={['W49', 'W50']} />
          <MatchM id="W58" placeholders={['W53', 'W54']} teamz={['W53', 'W54']} />
          <MatchM id="W59" placeholders={['W51', 'W52']} teamz={['W51', 'W52']} />
          <MatchM id="W60" placeholders={['W55', 'W56']} teamz={['W55', 'W56']} />
        </div>
        <div className={classes.roundsmobile} style={{ display: match.params.bracketSection === 'semis' ? 'flex' : 'none' }}>
          <MatchM id="W61" placeholders={['W57', 'W58']} teamz={['W57', 'W58']} />
          <MatchM id="W62" placeholders={['W59', 'W60']} teamz={['W59', 'W60']} />
        </div>
        <div className={classes.roundsmobile} style={{ display: match.params.bracketSection === 'thirdplace' ? 'flex' : 'none' }}>
          <MatchM id="W63" placeholders={['L61', 'L62']} teamz={['L61', 'L62']} roundName="3rd Place Play-Off" />
        </div>
        <div className={classes.roundsmobile} style={{ display: match.params.bracketSection === 'final' ? 'flex' : 'none' }}>
          <MatchM id="W64" placeholders={['W61', 'W62']} teamz={['W61', 'W62']} roundName="Final" />
        </div>
      </div>
    ))}
  </div>
);

Bracket.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Bracket);
